import * as Tools from '../tools.js';

document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

window.addEventListener('resize', Tools.debounce(() => {
    window.dispatchEvent(new CustomEvent('delayedResize'));
}));

let windowWidth = window.innerWidth;

window.addEventListener('resize', Tools.debounce(() => {
    if (windowWidth !== window.innerWidth) {
        windowWidth = window.innerWidth;

        window.dispatchEvent(new Event('delayedResize'));
    }
}));

let resizeTimeout;
window.addEventListener('resize', () => {
    if (windowWidth !== window.innerWidth) {
        windowWidth = window.innerWidth;

        clearTimeout(resizeTimeout);

        document.documentElement.classList.add('resize');

        resizeTimeout = setTimeout(() => document.documentElement.classList.remove('resize'), 300);
    }
});

window.addEventListener('load', function() {
    let featherlight = document.querySelector('.featherlight');
    if (featherlight) {
        let featherlightContent = document.querySelector('.featherlight .ce_text');
        let closeIcon = document.querySelector('.featherlight .ce_text .close-icon');
        window.addEventListener('click', function(e) {
            if (featherlightContent.contains(e.target)) {
                console.log('test');
                // Clicked in box
            } else {
                featherlight.style.display = 'none';
            }

            if (closeIcon.contains(e.target)) {
                featherlight.style.display = 'none';
            }
        });
    }
}, false);
